import { FolderGit2 } from '@orgus/ui/icons';
import { cn, Panel, plural, Pressable, RelativeTime, Sparkline } from '@orgus/ui';
import { HealthBadge, ScoreText } from './HealthBadge.tsx';
import type { RepoRow } from './model.ts';

/** Every watched repo, worst first: score, trend, status and when it was checked. */
export function RepoList({ rows, selected, onSelect }: { rows: RepoRow[]; selected: string | null; onSelect: (id: string) => void }) {
  return (
    <Panel title="Repositories" sub={plural(rows.length, 'repo')} icon={<FolderGit2 />} flush>
      <ul className="divide-y divide-border-subtle" aria-label="Repositories by discipline score">
        {rows.map((r) => {
          const active = r.projectId === selected;
          const points = r.history.map((p) => p.score);
          return (
            <li key={r.projectId}>
              <Pressable
                onClick={() => onSelect(r.projectId)}
                aria-current={active ? 'true' : undefined}
                className={cn('flex items-center gap-3 px-4 py-2.5 hover:bg-hover', active && 'bg-active hover:bg-active')}
              >
                <ScoreText health={r.health} score={r.report?.score} className="w-8 shrink-0 text-right text-lg" />
                <span className="flex min-w-0 flex-1 flex-col gap-0.5">
                  <span className="truncate text-base font-medium text-fg">{r.name}</span>
                  <span className="flex min-w-0 items-center gap-2 text-sm text-fg-subtle">
                    <HealthBadge health={r.health} />
                    {r.report && (
                      <>
                        <span aria-hidden>·</span>
                        <RelativeTime ts={r.report.checkedAt} className="shrink-0" />
                      </>
                    )}
                  </span>
                </span>
                {points.length > 1 ? (
                  <Sparkline values={points} min={0} max={100} width={72} height={24} tone="neutral" label={`${r.name} score trend`} className="hidden shrink-0 sm:block" />
                ) : (
                  <span className="hidden w-18 shrink-0 text-right text-xs text-fg-subtle sm:inline">{r.report ? 'No trend yet' : ''}</span>
                )}
              </Pressable>
            </li>
          );
        })}
      </ul>
    </Panel>
  );
}
